import type { GridRenderHeaderFilterProps } from "@mui/x-data-grid-premium";
import { DataGridNumberHeaderFilterImpl } from "src/components/DataGrid/DataGridNumberHeaderFilterImpl.tsx";

export const DataGridNumberHeaderFilter = (
  props: GridRenderHeaderFilterProps,
) => {
  // this wrapper exists only to fix hot reloading in this component
  return <DataGridNumberHeaderFilterImpl {...props} />;
};
